class ImageWithTextVideo extends HTMLElement {
  connectedCallback() {
    this.videoElement = this.querySelector('video');
    if (!this.videoElement) return;

    this.observer = new IntersectionObserver(this.togglePlayback.bind(this), { threshold: 0.2 });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  togglePlayback([entry]) {
    if (entry.isIntersecting) {
      this.videoElement.play().then(() => this.observer.disconnect());
    } else {
      this.videoElement.pause();
    }
  }
}

customElements.define('image-with-text-video', ImageWithTextVideo);